import LanguagesForm from './languagesForm'
export default LanguagesForm
